$(document).ready(function(){
        $(document).on("change",".custm_prdt_varint .single-option-selector",function() {
          var product_quantity = $(this).closest('.custm_prdt_varint').find('.cus_sel option:selected').attr('data-quantity');
          if (product_quantity <= 0) {
            $('.cstm_by_now').hide();
          }
        });
         
        var promo_txt = $('.js-featured-promotions').hasClass('cstm-promo-feature');
        if(promo_txt == true){
          $('.cust-shop').hide();
          setTimeout(function() {
            $('.cust-shop').fadeIn(1000);
          }, 5000);
        }
      });

      $(document).ready(function(){
        $(document).on("click",".cus_cartpage",function() {
        //  window.location = "/cart";
        });
          
        $(document).on("click",".cus_cartpage a",function() {
        //  window.location = "/cart";
        });

        $('.tab-banner-slider').slick({
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          dots:false,
          arrows:false,
           lazyLoad: 'ondemand',
          centerMode:false,
          responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              // centerMode: true,

            }

          }, {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,


            }
          },  {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,

            }
          }]
        });
        
        $('.banner-slider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true, 
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                  dots: false
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });
      });

      $(document).ready(function(){
        $('.carousel').slick({
          speed: 500,
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          dots:false,
          arrows:false,
          centerMode:false,
          responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          }, {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          },  {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }]
        });
      });
      
      $(document).on("click","#custom_bynow",function() {
        var variant_id = $('.cus_sel').find(":selected").val();
        var data = {
          "id": variant_id,
          "quantity":1
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function() { 
            window.location = '/checkout';
          }
        });
      });
      
      $(document).on("click","#collection_bynow",function() {
        var buy_now_btn =  $(this).closest('.cstm-pdct-bodr').find('#collection_bynow').attr('data-value');
		    var data_buy = {
          "id": buy_now_btn,
          "quantity":1
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data_buy,
          dataType: 'json',
          success: function() { 
            window.location = '/checkout';
          },
            error: function () { 
          }
        });
      });
      
      $(document).on("click","#search_bynow",function() {
        var serch_now_btn =  $(this).closest('.product_row').find('#search_bynow').attr('data-value');
        var serch_buy = {
          "id": serch_now_btn,
          "quantity":1
        }
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: serch_buy,
          dataType: 'json',
          success: function() { 
            window.location = '/checkout';
          },
          error: function () { 
          }
        });
      });  
      
      $(document).ready(function(){
        $('.main-img-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          fade:true,
          autoplay: true,
          autoplaySpeed: 4000,
          speed: 300,
          lazyLoad: 'ondemand',
          asNavFor: '.thumb-nav',
          prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
          nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'
        });
        // Thumbnail/alternates slider for product page
        $('.thumb-nav').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          centerPadding: '0px',
          asNavFor: '.main-img-slider',
          dots: false,
          centerMode: false,
          draggable: true,
          speed:200,
          focusOnSelect: true,
          prevArrow: '<div class="slick-prev"><i class="i-prev"></i><span class="sr-only sr-only-focusable">Previous</span></div>',
          nextArrow: '<div class="slick-next"><i class="i-next"></i><span class="sr-only sr-only-focusable">Next</span></div>'  
        });
        //keeps thumbnails active when changing main image, via mouse/touch drag/swipe
        $('.main-img-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
          //remove all active class
          $('.thumb-nav .slick-slide').removeClass('slick-current');
          //set active class for current slide
          $('.thumb-nav .slick-slide:not(.slick-cloned)').eq(currentSlide).addClass('slick-current');  
        });
      });

      var flagUndoSlick = false;
      var flagAlreadyBuiltSlick = false;
      $( document ).ready(function(){
        if($(window).width() < 767) {
            flagUndoSlick = true;
            flagAlreadyBuiltSlick = true;
        	$('.itg_blog_slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
              fade:true,
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 300,
              lazyLoad: 'ondemand',
              nextArrow: '<button class="next_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/right-chevron.png?v=1653127707"></button>',
              prevArrow: '<button class="prev_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/left-chevron.png?v=1653127568"></button>',
            });
   //         	$('.six_grid').slick({
   //            slidesToShow: 1,
   //            slidesToScroll: 1,
   //            infinite: true,
   //            arrows: true,
   //            fade:true,
   //            autoplay: true,
   //            autoplaySpeed: 4000,
   //            speed: 300,
   //            lazyLoad: 'ondemand',
   //            nextArrow: '<button class="next_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/right-chevron.png?v=1653127707"></button>',
   //            prevArrow: '<button class="prev_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/left-chevron.png?v=1653127568"></button>',
			// });
          
   //        	$('.five_grid').slick({
   //            slidesToShow: 1,
   //            slidesToScroll: 1,
   //            infinite: true,
   //            arrows: true,
   //            fade:true,
   //            autoplay: true,
   //            autoplaySpeed: 4000,
   //            speed: 300,
   //            lazyLoad: 'ondemand',
   //            nextArrow: '<button class="next_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/right-chevron.png?v=1653127707"></button>',
   //            prevArrow: '<button class="prev_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/left-chevron.png?v=1653127568"></button>',
   //          });
          
   //        	$('.logo_t_img').click(function(){
   //    			$('.five_grid ').slick('refresh');
   //    			$('.six_grid ').slick('refresh');
   //        	});
          	
          	$('.mob_cart.cart-container.side_icon_inner a.mini_cart').on('click', function(e){
      			e.preventDefault();
          	});
        }
      });

      $( window ).resize(function(){
        if($(window).width() < 767) {
            if ( flagAlreadyBuiltSlick === false ) {
              $('.itg_blog_slider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: true,
                fade:false,
                autoplay: true,
                autoplaySpeed: 2000,
                speed: 200,
                lazyLoad: 'ondemand',
                nextArrow: '<button class="next_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/right-chevron.png?v=1653127707"></button>',
                prevArrow: '<button class="prev_button"><img src="https://cdn.shopify.com/s/files/1/0954/5580/files/left-chevron.png?v=1653127568"></button>',
              });
              flagAlreadyBuiltSlick = true;
              flagUndoSlick = true;
            }
          	
          	$('.mob_cart.cart-container.side_icon_inner a.mini_cart').on('click', function(e){
      			e.preventDefault();
          	});
        } else {
          if ( flagUndoSlick === true ) {
        	$('.itg_blog_slider').slick('unslick');
            $('.itg_blog_slider').children().css( "opacity", "1" );
            flagUndoSlick = false;
            flagAlreadyBuiltSlick = false;
          }
        }
      });
   